export default __webpack_public_path__ + "static/media/bumperCar.30b3e0df.png";